/**
 * Returns a new array with the given value toggled:
 * - If `value` is already present in `array` (by strict equality), it is removed.
 * - If `value` is not present, it is appended to the end of the array.
 *
 * This function is immutable: it does not modify the original array.
 *
 * @template T
 * @param {T[]} array - The source array to toggle the value in.
 * @param {T} value - The value to add or remove from the array.
 * @returns {T[]} A new array with the value either added or removed.
 *
 * @example
 * const initial = ['a', 'b'];
 *
 * toggleInArray(initial, 'b'); // ['a']
 * toggleInArray(initial, 'c'); // ['a', 'b', 'c']
 */
export const toggleInArray = <T>(array: T[], value: T): T[] => {
  return array.includes(value) ? array.filter((v) => v !== value) : [...array, value];
};
